module.exports = __webpack_public_path__ + "static/assets/f5e78869d96cc5123a3cf0864938f2f8.png";